export const BRAND_ACCENT = '#e14a7a';
export const APP_THEME_STORAGE_KEY = 'bruno_theme_mode';

const SHARED_STATUS = {
  accent: '#f76464',
  success: '#46bf83',
  warning: '#ffa400',
  error: '#fe2d38',
  infoLight: '#005c97',
  infoDark: '#60A5FA',
};

export const LIGHT_TOKENS = {
  mode: 'light',
  colors: {
    primary: '#1a242d',
    background: '#F2F2F7',
    surface: '#ffffff',
    secondary: '#5F5F5F',
    inactive: '#F5F5F5',
    lightgray: '#C4C4C4',
    borderCard: '#F5F5F5',
    textPrimary: '#1a242d',
    textSecondary: '#5F5F5F',
    textMuted: '#8e8e93',
    textInverse: '#ffffff',
    textInverseSub: 'rgba(255,255,255,0.85)',
    white: '#ffffff',
    black: '#000000',
  },
  chrome: {
    appBarBackground: '#1a242d',
    appBarForeground: 'rgba(255,255,255,0.8)',
    sidebarBackground: '#1a242d',
    sidebarForeground: 'rgba(255,255,255,0.8)',
    sidebarSelected: '#252f3d',
    sidebarSelectedHover: '#2c3848',
    sidebarHover: 'rgba(255,255,255,0.05)',
    sidebarActiveBackground: 'rgba(225,74,122,0.15)',
    sidebarActiveForeground: '#e14a7a',
    menuSurface: '#1a242d',
    menuDivider: 'rgba(255,255,255,0.2)',
    menuHover: 'rgba(255,255,255,0.08)',
    menuSelected: 'rgba(255,255,255,0.15)',
    menuSelectedHover: 'rgba(255,255,255,0.2)',
  },
  status: {
    accent: SHARED_STATUS.accent,
    success: SHARED_STATUS.success,
    warning: SHARED_STATUS.warning,
    error: SHARED_STATUS.error,
    info: SHARED_STATUS.infoLight,
  },
};

export const DARK_TOKENS = {
  mode: 'dark',
  colors: {
    primary: '#F8FAFC',
    background: '#020408',
    surface: '#0D1117',
    secondary: '#94A3B8',
    inactive: '#161B22',
    lightgray: '#475569',
    borderCard: '#21262D',
    textPrimary: '#FFFFFF',
    textSecondary: '#8B949E',
    textMuted: '#6E7681',
    textInverse: '#ffffff',
    textInverseSub: 'rgba(255,255,255,0.85)',
    white: '#ffffff',
    black: '#000000',
  },
  chrome: {
    appBarBackground: '#0D1117',
    appBarForeground: 'rgba(255,255,255,0.88)',
    sidebarBackground: '#0D1117',
    sidebarForeground: 'rgba(255,255,255,0.88)',
    sidebarSelected: '#161B22',
    sidebarSelectedHover: '#21262D',
    sidebarHover: 'rgba(255,255,255,0.06)',
    sidebarActiveBackground: 'rgba(225,74,122,0.15)',
    sidebarActiveForeground: '#e14a7a',
    menuSurface: '#0D1117',
    menuDivider: '#21262D',
    menuHover: 'rgba(255,255,255,0.06)',
    menuSelected: 'rgba(255,255,255,0.12)',
    menuSelectedHover: 'rgba(255,255,255,0.18)',
  },
  status: {
    accent: SHARED_STATUS.accent,
    success: SHARED_STATUS.success,
    warning: '#F59E0B',
    error: SHARED_STATUS.error,
    info: SHARED_STATUS.infoDark,
  },
};

export const getThemeTokens = mode => (mode === 'dark' ? DARK_TOKENS : LIGHT_TOKENS);
